import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { GeocercasService } from './../../../../../monitoreo/services/geocercas.service';
import { VehiculoGeocerca } from './../../../../../../_entities/geocerca/vehiculo-geocerca';
import { IGNICIONES, ALERTAS } from './../../../../../../_entities/estados';
import { MapaMarkerComponent } from '../../../mapa-marker/mapa-marker.component';
import { ToastrService } from 'ngx-toastr';


@Component({
	selector: 'kt-fuera-geocerca',
	templateUrl: './fuera-geocerca.component.html',
	styleUrls: ['./fuera-geocerca.component.scss']
})
export class FueraGeocercaComponent implements OnInit {
	public reporteFueraGeocerca: VehiculoGeocerca[]
	public geocercas;
	public geocerca;
	public fechaInicio;
	public fechaFin;
	public showFilterRow: boolean;
	public idVehiculo: number;
	public datosReporte = [];
	public loadingVisible: boolean = false;
	public isDisabled: boolean = true;
	public showTable: boolean = false;

	constructor(private geocercasService: GeocercasService,
		private datepipe: DatePipe,
		private dialog: MatDialog,
		private toastService: ToastrService,
		private dialogRef: MatDialogRef<FueraGeocercaComponent>,
		@Inject(MAT_DIALOG_DATA) public vehiculo) {
		this.showFilterRow = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		this.idVehiculo = this.vehiculo.id
		this.obtenerGeocercas()
	}

	obtenerFueraGeocerca(fechaInicio, fechaFin, idGeocerca){
		this.loadingVisible = true;
		const fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd");
		const fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd");

		this.geocercasService.obtenerVehiculoFueraGeocerca(this.idVehiculo, idGeocerca, fechaInicial, fechaFinal).pipe(
			finalize(
				() => { this.loadingVisible = false; }
			)
		).subscribe(
			(posiciones: VehiculoGeocerca[]) => {
				posiciones.map(posicion => {

					const ignicion = IGNICIONES.find(ignicion => ignicion.id == posicion.ignicion);
					posicion.ignicion = ignicion.nombre;

					const estado = ALERTAS.find(alerta => alerta.id == posicion.estado);
					posicion.estado = estado.nombre;

					posicion.fecha = this.datepipe.transform(posicion.fecha, 'dd/MM/yyyy HH:mm');

				});

				this.reporteFueraGeocerca = posiciones;
				this.reporteFueraGeocerca.forEach(vehiculo => {
					this.datosReporte.push({
						'Vehiculo': vehiculo.descripcion,
						'Placas': vehiculo.placas,
						'Estado': vehiculo.estado,
						'Ignición': vehiculo.ignicion,
						'Fecha': vehiculo.fecha
					});
				});
				if(this.datosReporte.length){
					this.isDisabled = false;
					this.showTable = true;
				} else {
					this.toastService.info('No se encontraron datos');
				}
			}
		)
	}

	obtenerGeocercas() {
		this.geocercasService.getGeoCercas().subscribe(
			(geocerca) => {
				this.geocercas = geocerca;
			}
		)

	}

	ubicarPunto(data) {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.width = "40%";
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		dialogConfig.data = this.vehiculo;
		this.dialog.open(MapaMarkerComponent, dialogConfig);
	}

	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
